import { ClientError } from "../client/client-error";
import { IHttpClient } from "./http-client-interface";
import { HttpError } from "./http-error";
import { HttpResponseError } from "./http-response-error";
import {ResponseBase} from "./response-base";
import {v4 as uuidv4} from 'uuid';
import { LoggerInterface,  } from '@aws-lambda-powertools/logger/types';
import { BodyInit, HeadersInit } from "undici-types/fetch";

export class HttpClient implements IHttpClient {

    
    private headers : Record<string,string> = {}

    private baseUrl: string = ".";
    
    private logger : LoggerInterface;

    constructor(logger : LoggerInterface) {
        this.logger = logger;
    }

    /**
     * 
     * @returns The configuration service base URL
     */
    getBaseUrl(): string {
        return <string>this.baseUrl;
    }

    setBaseUrl(baseUrl : string) : void {
        this.baseUrl = baseUrl;
    }

    setCommonHeaders(headers : Record<string,string>) : void{
        this.headers = headers;
    }


    async request(httpMethod: string, path: string, query?: URLSearchParams, body?: any): Promise<any> {
        httpMethod = httpMethod.toUpperCase();

        if (query === undefined) {
            query = new URLSearchParams();
        }

        const url = this.getBaseUrl() + '/' + path + (query.size > 0 ? '?' + query.toString() : '');

        const request: RequestInit = {
            method: httpMethod.toUpperCase(),
            headers: { ...this.headers} // Clone headers
        }

        console.log(`HttpClient::_request: httpMethod=[${httpMethod}], url=[${url}]`);
        if (httpMethod === 'POST') {
            this.logger.debug(`HttpClient::_request: body=[${JSON.stringify(body)}]`);
            console.log("HttpClient::_request: body:", body);
            request.body = JSON.stringify(body);
            // @ts-ignore request.Headers is always set.
            request.headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(url, request);

        let data: ResponseBase | null = null;

        const contentType: string = <string>response.headers.get("Content-Type");
        switch (contentType) {
            case "application/json":
                data = (await response.json()) as ResponseBase;
                break;
            default:
                throw new HttpResponseError(`Unsupported content type: ${contentType}`, response);
        }

        data = this._checkResponse(data);

        return data.Result;
    }


    /**
     *
     * @param url
     * @returns 
     */
    async downloadFile(url : string, query?: URLSearchParams) : Promise<ArrayBuffer>{
        if (query === undefined) {
            query = new URLSearchParams();
        } 

        const parsedUrl = new URL(url)

        query.forEach((value, key) => {
            parsedUrl.searchParams.set(key, value);
        });


        //url = url + (query.size > 0 ? '?' + query.toString() : '');
        url = parsedUrl.toString();

        
        const response = await fetch(url);

        if (!response.ok) {
            throw new HttpResponseError("Object cannot be downloaded from Studio.", response);
        }

        const buffer = await response.arrayBuffer();

        console.log(`Downloaded ${buffer.byteLength} bytes`);

        return buffer;
    }

    /**
     * Upload a file to the Studio transfer server.
     * 
     * 
     * @param body 
     * @param size
     * @param contentType 
     * @param ticket 
     * @param studiobaseUrl The Studio base url
     *
     * @returns The url to the uploaded file
     */
    async uploadFile(body : BodyInit, size : number | null, contentType : string, ticket : string, studiobaseUrl : string) : Promise<string> {
        this.logger.debug(`HttpClient::uploadFile: ticket=[${ticket}], studiobaseUrl=[${studiobaseUrl}]`)

        const url = `${studiobaseUrl}/transferindex.php?ticket=${ticket}&fileguid=${uuidv4()}`;

        const headers : HeadersInit = {
            'Content-Type' : contentType,
        }

        if(size !== null) {
            headers['Content-Length'] = String(size);
        }

        const response = await fetch(url, {
            method: 'PUT',
            // To prevent the error: RequestInit: duplex option is required when sending a body
            // Note: The order is important!!!! The 'duplex' setting must be set before the body otherwise it will be ignored.
            duplex: 'half',
            body: body,
            headers: headers
        });

        if (!response.ok) {
            throw new HttpResponseError('Unable to upload file.',response);
        }

        return url;
    }

    /**
     * @param {object} data
     * @private
     */
    _checkResponse(data: ResponseBase | null) : ResponseBase {
        console.log("HttpClient::_checkResponse: ", data);

        if (data === null) {
            throw new HttpError("No JSON data received");
        }

        if (data.hasOwnProperty('Status')) {
            if (data.Status !== 'ok') {
                if (data.StatusMessage !== undefined) {
                    throw new ClientError(`The status is not 'ok': ${data.Status}: ${data.StatusMessage}`);
                } else {
                    throw new ClientError(`The status is not 'ok': ${data.Status}`);
                }
            }
        } else {
            throw new HttpError("No 'Status' property found in response");
        }

        if (!data.hasOwnProperty('Result')) {
            throw new HttpError("No 'Result' property found in response");
        }

        return data;
    }

    _sanitizeUrl(url: string): string {
        return url.replace(/\/$/, "");
    }
}